var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"split content split-horizontal second-wishlist",attrs:{"id":"charScreeen"}},[_c('span',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.create_liveCandle))]),_vm._v(" "),(_vm.loading == 1)?_c('chart-loader'):_vm._e(),_vm._v(" "),_c('div',{ref:"chartContainer",staticClass:"TVChartContainer comPopup"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be2be5e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/website/shared/trading-view.vue
// module id = null
// module chunks = 